const COOKIE_KEY = "cb_ecom";

const Api = {
  //Url: "http://localhost/git/shibani-website/api/api/",
  Url: "https://shibanifashion.com/site/api/",
  ImageUrl: "https://shibanifashion.com/billing/services/",
  CloudImageUrl: "https://shibanifashion.com/files_list/",
};

export { COOKIE_KEY, Api };
